import { useState } from "react";
import { toast } from "sonner";
import { getOpenAIClient } from "@/lib/openai";
import { enhanceInstructionsWithAI } from "../utils/openaiUtils";

export const useAssistantForm = (
  onSave: (assistant: { id: string; name: string }) => void,
  initialInstructions: string = ""
) => {
  const [instructions, setInstructions] = useState(initialInstructions);
  const [isLoading, setIsLoading] = useState(false);
  const [isEnhancing, setIsEnhancing] = useState(false);

  const handleEnhanceInstructions = async (name: string, currentInstructions: string): Promise<void> => {
    console.log('Enhancing instructions with:', { name, currentInstructions });
    setIsEnhancing(true);
    
    try {
      const openai = await getOpenAIClient();
      const enhanced = await enhanceInstructionsWithAI(openai, name, currentInstructions);
      if (enhanced) {
        console.log('Enhanced instructions received:', enhanced);
        setInstructions(enhanced);
      }
    } catch (error) {
      console.error('Error enhancing instructions:', error);
      toast.error("Failed to enhance instructions");
    } finally {
      setIsEnhancing(false);
    }
  };

  return {
    instructions,
    setInstructions,
    isLoading,
    setIsLoading,
    isEnhancing,
    handleEnhanceInstructions
  };
};